import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_methods_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, id?: number[], idsToExclude?: number[] }): 
  Promise<{ result: { Id?: number, EnumName?: string, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_methods_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, id?: number[], idsToExclude?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, EnumName?: string, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_methods_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, id?: number[], idsToExclude?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, EnumName?: string, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_methods_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string, id?: number[], idsToExclude?: number[]    }) {
      return false;
    }
}
